import { FormProvider, useForm } from 'react-hook-form';
import { IFrameBankStatements } from './IFrameBankStatements';
import { Button, media, styled } from '@payright/web-components';
import SCSpinner from '../../../components/spinner';
import { useState } from 'react';
import { ButtonCancelPlan } from '../../../components/buttons/ButtonCancelPlan';

export type BankStatementsFormData = {
  hasDetectedBsoSubmission: boolean;
};

type BankStatementsFormProps = {
  loading: boolean;
  customerNumber: string;
  onSubmit: (data: BankStatementsFormData) => void;
  onModify?: () => void;
  onCancel?: () => void;
};

const StyledForm = styled.form`
  display: grid;
  grid-gap: 3rem;

  .buttons {
    display: flex;
    gap: 1.5rem;
    flex-direction: column-reverse;
  }

  ${media.min.small} {
    .buttons {
      flex-direction: row;
    }
  }
`;

export const FormBankStatements = ({
  loading,
  customerNumber,
  onSubmit,
  onModify,
  onCancel,
}: BankStatementsFormProps) => {
  const [bsoSubmitted, setBsoSubmitted] = useState(false);

  const reactHookFormBsoData = useForm();
  const { handleSubmit } = reactHookFormBsoData;

  const formSubmitHandler = () => {
    onSubmit({
      hasDetectedBsoSubmission: bsoSubmitted,
    });
  };

  const handleBsoModified = () => onModify?.();

  return (
    <FormProvider {...reactHookFormBsoData}>
      <StyledForm onSubmit={handleSubmit(formSubmitHandler)}>
        <IFrameBankStatements
          // TODO - better fallback bso url
          url={
            process.env.REACT_APP_BSO_URL || 'https://www.bankstatements.com.au/iframe/start/PRAU'
          }
          customerNumber={customerNumber}
          loading={loading}
          onBsoSubmitted={() => setBsoSubmitted(true)}
          onBsoModified={handleBsoModified}
        />
        <div className="buttons">
          <ButtonCancelPlan disabled={loading} />
          <Button disabled={loading} maxWidth="100%" icon={loading ? <SCSpinner /> : undefined}>
            I've submitted my Bank Statements
          </Button>
        </div>
      </StyledForm>
    </FormProvider>
  );
};
